"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostSalesmanChangePassword = void 0;
const Base_1 = require("./Base");
exports.PostSalesmanChangePassword = {
    url: Base_1.URL_BASE + "/SalesmanChangePassword",
    method: "POST",
    secure: true
};
//# sourceMappingURL=PostSalesmanChangePassword.js.map